//-------------------------------------------------------------------------------------------------- Imports
import { StyleSheet } from "../StyleSheet";
import { images } from "../routes/ImageRoutes";

//-------------------------------------------------------------------------------------------------- Component
const Loading = () => {
    return (
        <div style={styles.mainContainer}>
            <img
                style={styles.loadingGif}
                src={images.loadingBlue}
                alt="Cargando..."
            />
            <h3>
                Cargando...
            </h3>
        </div>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    mainContainer: {
        display: "flex",
        width: "100%",
        height: "100vh",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        backgroundColor: "transparent",
    },
    loadingGif: {
        width: 100,
        height: 100,
    }
});

//-------------------------------------------------------------------------------------------------- Exports
export default Loading;
